import { constants } from "../constants/redux-constants";

const initialState = {
  loading: false,
  progress: false,
  encLoading:false,
  templateLoading:false
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SHOW_LOADER:
      return {
        ...state,
        loading: true,
      };
    case constants.HIDE_LOADER:
      return {
        ...state,
        loading: false,
      };
    case constants.PROGRESS_STATUS:
      return {
        ...state,
        progress: action?.payload,
      };
    case constants?.SET_ENC_LOADING:
      return {
        ...state,
        encLoading: action?.payload,
      };
    case constants?.SET_TEMPLATE_LOADING:
      return {
        ...state,
        templateLoading: action?.payload,
      };
    default:
      return state;
  }
};

export default loaderReducer;
